/*
 *
 * Package: `@dbh/button-with-icon-theme`.
 *
 */const iconPositions={top:{flexDirection:"column"},bottom:{flexDirection:"column-reverse"},left:{flexDirection:"row"},right:{flexDirection:"row-reverse"}};const buttonWithIconValuesIconPositions=Object.keys(iconPositions);const THEME_KEY_BUTTON_WITH_ICON="buttonWithIcon";const buttonWithIconTheme={buttonWithIcon:{iconPositions}};

export { THEME_KEY_BUTTON_WITH_ICON, buttonWithIconValuesIconPositions, buttonWithIconTheme as default, iconPositions };
